import type { Decorator } from 'final-form';

import * as types from './types';

export const resetValidationOnToggleSaveAsTemplateDecorator: Decorator<types.FormValues> = (formApi) => {
  return formApi.registerField(
    'isNewTemplate',
    () => {
      formApi.getRegisteredFields().forEach((fieldName) => {
        const fieldState = formApi.getFieldState(fieldName as keyof types.FormValues);

        if (fieldState) {
          formApi.resetFieldState(fieldName as keyof types.FormValues);
        }
      });
    },
    { value: true },
  );
};

export const toggleSaveOnChangeTemplateDecorator: Decorator<types.FormValues> = (formApi) => {
  return formApi.registerField(
    'template',
    (fieldState) => {
      if (fieldState.value?.id) formApi.change('isNewTemplate', true);
    },
    { value: true },
  );
};
